export default function initTableGroupToggles() {
  const toggles = document.querySelectorAll(".group-toggle");

  toggles.forEach(toggle => {
    toggle.addEventListener("click", () => {
      const group = toggle.getAttribute("data-group");
      const rows = document.querySelectorAll(`.child-row.${group}`);
      const icon = toggle.querySelector(".toggle-icon");

      rows.forEach(row => row.classList.toggle("d-none"));

      if (icon) {
        icon.classList.toggle("ri-arrow-down-s-line");
        icon.classList.toggle("ri-arrow-up-s-line");
      }
    });
  });
}
